module.exports = __webpack_public_path__ + "static/frost_giant_skeleton-b949e36f7bca3107f87aa3fc88e768a4.jpg";